import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const MKIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="MK" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#F50100"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G fill="#FFD018" mask="url(#b)">
        <Path d="M16 9.988v2.042h-1.628L9 7.012l7 2.976Zm-14.372 2.03H0V9.975L7 7l-5.372 5.017Zm7.872-.019h-3L8 6l1.5 6ZM6 6 0 7.5v-3L6 6Zm10 1.5L10 6l6-1.5v3ZM8 6 6.5 0h3L8 6Zm8-3.966L9 5.008l5.372-5.017H16v2.042ZM7 4.997 0 2.02V-.021h1.628L7 4.997Z" />
        <Path
          stroke="#F50100"
          d="M8 3.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Z"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
